var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('change-pwd',{attrs:{"type":"phone"},on:{"findSuccess":_vm.findSuccess,"changeCom":_vm.changeCurrentCom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }